let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Xi5AP")).then(() => parcelRequire('jwd3r'));